import type { Audience_Insert_Input } from '@openx/types/gqlTypes';

export const transformAudienceDetailsToInput = (
  userId: string,
  accountId: string,
  {
    name,
    description,
    direct_audience_provider,
    export_targets,
    export_type,
    normalized_definition,
  }: Partial<Audience_Insert_Input>
) => ({
  user_id: userId,
  account_id: accountId,
  name,
  description,
  direct_audience_provider,
  export_targets,
  export_type,
  normalized_definition,
  status: 'draft',
  type: 'v2',
  data_source: 'OpenAudience',
  region: 'US',
});
